import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Popup from "reactjs-popup";
import "./EditableShortIntro.css"
import ShortIntro from "../../../../clients/PastGeb/components/ShortIntro/ShortIntro";
import fetchPastEditionIntroduction from "../../../../clients/PastGeb/components/Introduction/packages/fetchPeIntroduction";
import fetchShortIntroduction from "../../../../clients/PastGeb/components/ShortIntro/packages/fetchShortIntroduction";
import UpdateShortIntroduction from "./package/UpdateShortIntro";

const EditButton = ({ id }) => {
    const [contents, setcontents] = useState('');
    const [btnLoading, setBtnLoading] = useState(false);

    let [shortIntro, setShortIntro] = useState({});
    useEffect(() => {
        if (id)
            fetchShortIntroduction({
                editionId: id,
                setShortIntro: setShortIntro
            })
    }, []);

    useEffect(() => {
        setcontents(shortIntro.content ?? "");
    }, [shortIntro]);

    function refreshPage() {
        window.location.reload();
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        let success = await UpdateShortIntroduction({
            btnLoading: btnLoading,
            setBtnLoading: setBtnLoading,
            editionId: id,
            content: contents,
        });
        if (success) {
            refreshPage();
        }
    };

    return (
        <Popup
            trigger={
                <div className="ehp_edit_btn">
                    Edit
                </div>
            }
            modal
        >
            {(close) => {
                return (
                    <div className="ehp_edit_popup">
                        <div className="ehp_inner_container pg_inner_container">
                            <form className="ehp_form_container" onSubmit={handleSubmit}>
                                <h1 className="ehp_form_container_header">Edit Short Introduction</h1>
                                <div className="ehp_form_top">
                                    <div className="ehp_form_right">
                                        <label htmlFor="Contents" className="geb_form_label">
                                            Enter Contents:
                                        </label>
                                        <textarea
                                            style={{
                                                height: "25rem",
                                                width: "50rem"
                                            }}
                                            id="Contents"
                                            value={contents}
                                            onChange={(e) => {
                                                setcontents(e.target.value);
                                            }}
                                            className=" ehp_input_field"
                                            placeholder=""
                                            required
                                        ></textarea>
                                    </div>
                                </div>
                                <div className="ehp_form_bottom">
                                    <input
                                        type="submit"
                                        className="ehp_submit primary_btn"
                                        value={btnLoading ? "Loading..." : "Submit"}
                                    />
                                    <input
                                        type="button"
                                        className="ehp_cancel primary_btn "
                                        onClick={() => {
                                            close();
                                        }}
                                        value={"Cancel"}
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                );
            }}
        </Popup>
    );
};

const EditableShortIntro = ({ id, nth }) => {

    return (
        <div className="editableHomePage_container">
            <EditButton id={id} />
            <ShortIntro id={id} nth={nth} />
        </div>
    );
};

export default EditableShortIntro;
